import request from '@/utils/request'
export function getPage(condition, pagination) {
    return request({
      url: "/crm/product/generals/page",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  
  export function saveOrUpdate(data) {
    return request({
      url: "/crm/product/generals/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/crm/product/generals/get",
      method: "get",
      params: { id },
    });
  }
  
  export function deleteById(id) {
    return request({
      url: "/crm/product/generals/deleteById",
      method: "post",
      data: { id: id },
    });
  }